import { render, staticRenderFns } from "./ComparisonItemCompareModal.vue?vue&type=template&id=0df103c0"
import script from "./ComparisonItemCompareModal.vue?vue&type=script&lang=ts"
export * from "./ComparisonItemCompareModal.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonItemCompareModal.vue?vue&type=style&index=0&id=0df103c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports